export default __webpack_public_path__ + "static/media/settings.b258d63f.svg";